export default __webpack_public_path__ + "static/Verlag-Black-066415e47fcd2250e67ac2e4630088f4.woff2";